import { Component } from '@theme/component';
import { CartLinesUpdateEvent } from '@shopify/events';

/** Cross-sell add: exact Theme13 id/quantity payload, Horizon cart update and inline errors. */
class GbPdpBundleSave extends Component {
  #listeners;
  #requests = new Map();
  #timers = new Set();
  connectedCallback() { super.connectedCallback(); this.#initialize(); }
  updatedCallback() { super.updatedCallback(); this.#initialize(); }
  disconnectedCallback() { super.disconnectedCallback(); this.#cleanup(); }
  #cleanup() {
    this.#listeners?.abort();
    for (const [button, request] of this.#requests) { request.abort(); this.#label(button, button.dataset.addLabel); button.disabled = false; }
    this.#requests.clear();
    for (const timer of this.#timers) clearTimeout(timer);
    this.#timers.clear();
  }
  #initialize() {
    this.#cleanup();
    this.#listeners = new AbortController();
    this.addEventListener('click', this.#click, { signal: this.#listeners.signal });
  }
  #label(button, label) {
    const target = button.querySelector('.gb-btn__text') || button;
    target.textContent = label;
    if (target.hasAttribute('data-text')) target.dataset.text = label;
  }
  /** @param {MouseEvent} event */
  #click = async event => {
    const button = event.target instanceof Element ? event.target.closest('[data-save-add]') : null;
    if (!(button instanceof HTMLButtonElement) || button.disabled || !button.dataset.variantId) return;
    const request = new AbortController();
    this.#requests.set(button, request);
    button.disabled = true;
    const status = button.closest('.gb-yard-save-item__action')?.querySelector('[data-save-status]');
    if (status) { status.hidden = true; status.textContent = ''; }
    this.#label(button, this.dataset.addingLabel);
    let added = false;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(button.dataset.variantId), quantity: 1 }), signal: request.signal });
      const item = await response.json();
      if (!response.ok || item.status) throw new Error(item.description || this.dataset.errorText);
      added = true;
      // A failed refresh must never invite a second add after the first one succeeded.
      let cart;
      try { const result = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, signal: request.signal }); if (result.ok) cart = await result.json(); } catch (error) { if (request.signal.aborted) throw error; }
      if (request.signal.aborted || !this.isConnected) return;
      this.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: button.dataset.variantId, quantity: 1 }], promise: Promise.resolve({ ...(cart ? { cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) } : {}), detail: { source: 'gb-pdp-bundle-save', items: cart?.items, didError: false } }) }));
      const drawer = document.getElementById('cart-drawer');
      if (typeof drawer?.open === 'function' && !drawer.isOpen) drawer.open();
      this.#label(button, this.dataset.addedLabel);
    } catch (error) {
      if (request.signal.aborted) return;
      this.#label(button, added ? this.dataset.addedLabel : this.dataset.retryLabel);
      if (!added && status) { status.textContent = error.message || this.dataset.errorText; status.hidden = false; }
    } finally {
      if (!request.signal.aborted && this.isConnected) {
        const timer = setTimeout(() => { this.#timers.delete(timer); this.#requests.delete(button); button.disabled = false; this.#label(button, button.dataset.addLabel); }, 2000);
        this.#timers.add(timer);
      }
    }
  };
}
if (!customElements.get('gb-pdp-bundle-save')) customElements.define('gb-pdp-bundle-save', GbPdpBundleSave);
